<template>
  <div class="placeholder-wrapper -dropdown" :class="{'has-content': Boolean(internalValue)}">
    <app-select :label="label" :name="name" :options="options" v-model="internalValue"></app-select>
  </div>
</template>
<script>
  import AppSelect from '@atoms/Select'
  import ValueInputBindings from '@mixins/ValueInputBindings'

  export default {
    mixins: [ ValueInputBindings ],
    components: {
      AppSelect
    },
    props: {
      label: String,
      name: String,
      value: String,
      options: Array
    }
  }
</script>
